export default __webpack_public_path__ + "static/media/bell.701bdda1.svg";